import axios from "axios";
import config from "../constants/configs";
import { newRequestId } from "./session";

export const executeApi = async (path, body = {}) => {
  if (!config?.api) return { status: false, message: "Missing API config" };
  const token = localStorage.getItem("accessToken") || "";
  try {
    const response = await axios({
      method: "post", url: `${config.api}${path}`, timeout: 20000,
      headers: { "Content-Type": "application/json", accessToken: token, action: path, "x-client-request-id": newRequestId() },
      data: JSON.stringify(body),
    });
    if ((localStorage.getItem("accessToken") || "") !== token) return {status:false,reasonCode:"stale_response"};
    if (response.data === null || typeof response.data !== "object" || Array.isArray(response.data)) return response.data;
    return { ...response.data, requestId: response.headers?.["x-request-id"] };
  } catch {
    return { status: false, reasonCode: "transport_error" };
  }
};
export default executeApi;
